import { useEffect } from 'react';
import { analytics } from '../utils/analytics';

export const useErrorTracking = () => {
    useEffect(() => {
        const handleError = (event: ErrorEvent) => {
            analytics.captureException(event.error, {
                type: 'global_error',
                component: 'useErrorTracking',
            });
        };

        const handleUnhandledRejection = (event: PromiseRejectionEvent) => {
            analytics.captureException(event.reason, {
                type: 'unhandled_promise_rejection',
                component: 'useErrorTracking',
            });
        };

        window.addEventListener('error', handleError);
        window.addEventListener('unhandledrejection', handleUnhandledRejection);

        return () => {
            window.removeEventListener('error', handleError);
            window.removeEventListener('unhandledrejection', handleUnhandledRejection);
        };
    }, []);
}